<template>
  <div>
    <el-dialog append-to-body top="50px" :title="`命中配置查询`" :visible.sync="dialogVisible" width="50%"
      :before-close="handleClose">
      <el-form ref="form" :model="formChild" label-width="120px" style="padding: 0 50px;" :rules="rules">
        <el-form-item label="配置类型" prop="appType">
          <el-radio-group v-model="formChild.appType">
            <el-radio label="1">渠道</el-radio>
          </el-radio-group>
        </el-form-item>


        <el-form-item prop="appidFilterNames" label="渠道(appID)" v-if="formChild.appType == 1">
          <DynamicOption style="width:200px;" :singleSelect="true" v-model="formChild.appid" />
        </el-form-item>

        <!-- terminalType	终端类型: 1发送端 2接收端 radio -->
        <el-form-item label="终端类型" prop="terminalType">
          <el-radio-group v-model="formChild.terminalType">
            <el-radio label="1">发送端</el-radio>
            <el-radio label="2">接收端</el-radio>
          </el-radio-group>
        </el-form-item>


        <!-- customizedType	定制类型: 1SDK 2APP radio -->
        <el-form-item label="定制类型" prop="customizedType">
          <el-radio-group v-model="formChild.customizedType">
            <el-radio label="1">SDK</el-radio>
            <el-radio label="2">APP</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="厂商" prop="facturer">
          <el-input v-model="formChild.facturer"></el-input>
        </el-form-item>

        <el-form-item label="型号" prop="model">
          <el-input v-model="formChild.model"></el-input>
        </el-form-item>

        <el-form-item label="uid" prop="uid">
          <el-input v-model="formChild.uid"></el-input>
        </el-form-item>

        <el-form-item label="用户ID（uuid）" prop="uuid">
          <el-input v-model="formChild.uuid"></el-input>
        </el-form-item>

        <el-form-item label="应用版本" prop="appVer">
          <el-input v-model="formChild.appVer"></el-input>
        </el-form-item>

        <el-form-item label="SDK版本" prop="sdkVer">
          <el-input v-model="formChild.sdkVer"></el-input>
        </el-form-item>

        <el-form-item label="系统版本" prop="osVer">
          <el-input v-model="formChild.osVer"></el-input>
        </el-form-item>

        <el-form-item label="解码器" prop="codec">
          <el-input v-model="formChild.codec"></el-input>
        </el-form-item>
      </el-form>

      <div class="dialog-footer">
        <el-button @click="$emit('input', false)">取 消</el-button>
        <el-button type="primary" @click="configCommonSave">发起查询</el-button>
      </div>

      <el-input type="textarea" v-loading="loading" :rows="15" placeholder="响应结果" v-model="formChild.value">
      </el-input>

    </el-dialog>

  </div>
</template>

<script>

import { getHitConfig } from '@/api/apps/playConfig/strategyConfig';

import DynamicOption from '@/components/DynamicOption/index.vue';
export default {
  components: {
    DynamicOption
  },
  props: {
    value: {
      type: Boolean,
      default: () => false
    },
  },
  data() {
    return {
      loading: false,
      formChild: {
        appVer: '',
        codec: '',
        facturer: '',
        model: '',
        osVer: '',
        sdkVer: '',
        uid: '',
        uuid: '',
        terminalType: '',
        platform: '',
      },

    };
  },
  computed: {
    dialogVisible() {
      return this.value
    },
    rules() {
      let rulesData = {
        // appid uid  model codec osVer factory 必填
        appType: [
          { required: true, message: '配置类型', trigger: 'change' }
        ],
        appid: [
          { required: true, message: '请选择渠道', trigger: 'change' }
        ],
        uid: [
          { required: true, message: '请输入uid', trigger: 'change' }
        ],
        model: [
          { required: true, message: '请输入型号', trigger: 'change' }
        ],
        codec: [
          { required: true, message: '请输入解码器', trigger: 'change' }
        ],
        osVer: [
          { required: true, message: '请输入系统版本', trigger: 'change' }
        ],
        facturer: [
          { required: true, message: '请输入厂商', trigger: 'change' }
        ],
      }


      this.$nextTick(() => {
        this.$refs['form'] && this.$refs['form'].clearValidate()
      })
      return rulesData
    }
  },


  methods: {

    // 保存
    configCommonSave() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.loading = true
          const params = { ...this.formChild }
          params.appid = String(params.appid)
          getHitConfig(params).then(res => {
            console.log('getHitConfig+++++++++', res)
            this.loading = false
            if (res.data.code == 200) {

              this.formChild.value = JSON.stringify(JSON.parse(res.data.data), null, '\t')
            }
          })
          console.log(valid)


        }
      });



    },

    handleClose() {
      this.$confirm('确认关闭？')
        .then(_ => {
          this.$emit('input', false)
        })
        .catch(_ => { });
    }
  }
};
</script>
<style scoped lang="scss">
.dialog-footer {
  text-align: center;
  padding: 10px 0 20px;
}
</style>
